module.exports = __webpack_public_path__ + "img/credit-card-lock.af81f1c8.svg";